import React, { useState, useEffect, useMemo } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  TextField,
  NumberField,
  Paragraph,
  Dropdown,
  Checkbox,
  Toggle,
  RadioButton,
  Link,
  DateTime,
} from "../../page/Manage Component/Components/CustomizedComponent";
import { SET_TEMPLATE_GRID_LAYOUT_DATA } from "../../redux/constants/index";
import swal from "@sweetalert/with-react";
import CustomeModal from "../modal-popup/customeModal";

const ReusableGridLayoutPreview = ({
  setShowSetting,
  showSetting,
  setComponentForSetting,
  setShowWatermark,
  deletedComponentIdList,
  setDeletedComponentIdList,
  componentForSetting,
}) => {
  const ResponsiveGridLayout = useMemo(() => WidthProvider(Responsive), []);
  const location = useLocation();
  const { pathname } = location;

  const dispatch = useDispatch();
  const { componentListData } = useSelector((state) => state.manageComponent);
  const { componentGridLayoutData } = useSelector(
    (state) => state.bookingTemplate
  );

  const [layout, setLayout] = useState([]);
  const [isComponentDeleted, setIsComponentDeleted] = useState(false);

  const [droppedComponents, setDroppedComponents] = useState([
    componentListData,
  ]);

  // Add initial value to layout
  useEffect(() => {
    if (layout.length === 0) {
      setLayout(componentGridLayoutData);
    }
  }, [componentGridLayoutData]);

  const handleDrop = (_layout, droppedItem, _event) => {
    if (
      !componentGridLayoutData.some(
        (component) =>
          component.component.componentId === droppedItem.componentId
      )
    ) {
      const dragedElementData = _event.dataTransfer.getData("text");

      //   if (dragedElementData && dragedElementData.trim() !== "") {

      const dragedElement = JSON.parse(dragedElementData);

      const newPanel = {
        i: dragedElement.componentId.toString(),
        x: droppedItem.x,
        y: droppedItem.y,
        w: 2,
        h: 1,
        maxH: 1,
        minH: 1,
        // isResizable: true,
        // isDraggable: true,
        // isDroppable: true,
        component: dragedElement,
      };

      const updatedLayout = _layout.map((item) => {
        if (item.i.includes("dropping-elem")) {
          return newPanel;
        } else {
          const updatedArr = layout.find((oldItem) => oldItem.i === item.i);
          updatedArr.x = item?.x;
          updatedArr.y = item?.y;
          return updatedArr;
        }
      });

      // console.log({ _layout });
      setLayout(updatedLayout);

      setDroppedComponents((prevDroppedComponents) => [
        ...prevDroppedComponents,
        dragedElement,
      ]);

      //   }
    }
  };

  const handleResizeStop = (currentLayout, oldItem, newItem) => {
    const updatedLayout = currentLayout.map((currentItem) => {
      const matchingLayoutItem = layout.find(
        (item) => item.i === currentItem.i
      );

      newItem.h = oldItem.h;

      if (matchingLayoutItem) {
        return {
          ...matchingLayoutItem,
          x: currentItem.x,
          y: currentItem.y,
          w: currentItem.w,
          h: newItem.h,
        };
      } else {
        return {
          ...currentItem,
          component:
            layout.find((item) => item.i === currentItem.i)?.component || null,
        };
      }
    });

    setLayout(updatedLayout);

    dispatch({ type: SET_TEMPLATE_GRID_LAYOUT_DATA, payload: updatedLayout });
  };

  useEffect(() => {
    if (layout.length > 0) {
      dispatch({ type: SET_TEMPLATE_GRID_LAYOUT_DATA, payload: layout });
    }
  }, [layout]);

  const handleDraggedStop = (changedlayout) => {
    const updatedLayout = changedlayout.map((currentItem) => {
      return {
        ...currentItem,

        component:
          layout.find((item) => item.i === currentItem.i)?.component || null,
      };
    });

    setLayout(updatedLayout);
    dispatch({ type: SET_TEMPLATE_GRID_LAYOUT_DATA, payload: updatedLayout });
  };

  const handleDeleteComponent = (componentId, custome_field_id) => {
    setIsComponentDeleted(true);
    const updatedLayout = layout.filter((item) => item.i !== componentId);
    if (pathname.includes("update")) {
      setDeletedComponentIdList([...deletedComponentIdList, custome_field_id]);
    }
    setLayout(updatedLayout);
    dispatch({ type: SET_TEMPLATE_GRID_LAYOUT_DATA, payload: updatedLayout });
    if (updatedLayout.length === 0) {
      setShowWatermark(true);
    }
  };

  const handleLayoutChange = (newLayout) => {
    if (isComponentDeleted) {
      const updatedLayout = newLayout.map((currentItem) => {
        return {
          ...currentItem,
          component:
            layout.find((item) => item.i === currentItem.i)?.component || null,
        };
      });
      setLayout(updatedLayout);
      setIsComponentDeleted(false);
    }
  };

  // Function to get component based on there type
  const getComponent = (componentParameter) => {
    let custome_field_id;
    if (pathname.includes("activity")) {
      custome_field_id = componentParameter.component.custome_field_id;
    } else {
      custome_field_id =
        componentParameter.component.booking_template_custom_field_id;
    }
    switch (componentParameter?.component?.componentType) {
      case "text":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <TextField
              componentParameter={componentParameter.component}
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );
      case "number":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <NumberField
              componentParameter={componentParameter.component}
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  {" "}
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );
      case "paragraph":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <Paragraph
              componentParameter={componentParameter.component}
              calledFrom="form-builder"
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );
      case "dropdown":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <Dropdown
              componentParameter={componentParameter.component}
              dropdownOptions={
                componentParameter.component?.dropDownOption
                  ? componentParameter.component.dropDownOption.map(
                      (option) => {
                        const obj = {
                          label: option,
                          value: option,
                        };
                        return obj;
                      }
                    )
                  : []
              }
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  {" "}
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark cursor-pointer ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );

      case "check box":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <Checkbox
              {...componentParameter.component}
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  {" "}
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark cursor-pointer ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );

      case "toggle":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <Toggle
              {...componentParameter.component}
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  {" "}
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark cursor-pointer ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );
      case "radio group":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative overflow-y-auto`}
          >
            <RadioButton
              {...componentParameter.component}
              dropdownOptions={
                componentParameter.component?.dropDownOption
                  ? componentParameter.component.dropDownOption.map(
                      (option) => {
                        const obj = {
                          label: option,
                          value: option,
                        };
                        return obj;
                      }
                    )
                  : []
              }
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  {" "}
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark cursor-pointer ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );

      case "link":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <Link
              {...componentParameter.component}
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span className="fa-solid fa-lock"></span>
              ) : (
                <>
                  {" "}
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark cursor-pointer ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );

      case "date/time":
        return (
          <div
            className={`${
              componentParameter.component.componentId ===
              componentForSetting?.component?.componentId
                ? "bg-[--bg-color-500]"
                : "bg-[#F3F7FE]"
            } w-full h-full flex items-center justify-center rounded-lg p-3 relative`}
          >
            <DateTime
              componentParameter={componentParameter.component}
              isSelected={
                componentParameter.component.componentId ===
                componentForSetting?.component?.componentId
              }
            />
            <div className="absolute top-1 right-1 p-1 space-x-1">
              {componentParameter.component.is_immutable ? (
                <span class="fa-solid fa-lock"></span>
              ) : (
                <>
                  <span
                    className={`fa-solid fa-gear ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSetting(!showSetting);
                      setComponentForSetting(componentParameter);
                    }}
                  ></span>
                  <span
                    className={`fa-solid fa-xmark ${
                      componentParameter.component.is_immutable
                        ? "pointer-events-none"
                        : "cursor-pointer"
                    } ${
                      componentParameter.component.componentId ===
                      componentForSetting?.component?.componentId
                        ? "text-white"
                        : ""
                    }`}
                    onClick={() =>
                      swal({
                        content: (
                          <CustomeModal
                            type="delete"
                            title="Are you sure?"
                            content="You want to delete this component from template."
                            onDelete={() =>
                              handleDeleteComponent(
                                componentParameter.component.componentId,
                                custome_field_id
                              )
                            }
                          />
                        ),
                        buttons: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                      })
                    }
                  ></span>
                </>
              )}
            </div>
          </div>
        );

      default:
        return (
          <div className={`w-full h-full bg-[#F5F9FF] rounded-lg block`}></div>
        );
    }
  };

  return (
    <div
      className="w-full overflow-y-auto overflow-x-hidden"
      style={{
        maxHeight: "calc(100vh - 200px)",
        overflowX: "hidden",
      }}
    >
      <ResponsiveGridLayout
        style={{ height: `${componentListData.length * 100}px` }}
        className="layout"
        layouts={{ lg: layout, md: layout, sm: layout, xs: layout }}
        rowHeight={100}
        autoSize={true}
        isBounded={true}
        compactType={"horizontal"}
        isResizable={!Boolean(layout[0]?.component?.is_immutable)}
        useCSSTransforms={true}
        onDrop={handleDrop}
        isDraggable={!Boolean(layout[0]?.component?.is_immutable)}
        isDroppable={!Boolean(layout[0]?.component?.is_immutable)}
        onResizeStop={handleResizeStop}
        grid="auto"
        breakpoints={{ lg: 1280, md: 992, sm: 767, xs: 480 }}
        cols={{ lg: 4, md: 4, sm: 4, xs: 4 }}
        onDragStop={handleDraggedStop}
        onLayoutChange={handleLayoutChange}
        droppingItem={{ i: "dropping-elem", w: 2, h: 1 }}
      >
        {layout.map((item) => (
          <div key={item.i}>{getComponent(item)}</div>
        ))}
      </ResponsiveGridLayout>
    </div>
  );
};

export default ReusableGridLayoutPreview;
